// extracted by mini-css-extract-plugin
export default {"item":"styles_item__SCelI","text":"styles_text__den-v","subItem":"styles_subItem__d6r2g"};